@if (waiting()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading BAAs...</p>
  </div>
} @else {
  @if (baaObjectArray().length > 0) {
    <div class="connections-list">
      @for (baa of baaObjectArray(); track baa.baaNum) {
        <mat-card class="connection-card" (click)="navigateToBaa(baa)">
          <mat-card-content class="card-content">
            <div class="card-icon">
              <mat-icon>policy</mat-icon>
            </div>
            <div class="card-details">
              <div class="card-title">{{ baa.baaId || 'Unnamed BAA' }}</div>
              <div class="card-chips">
                @if (baa.status) {
                  <mat-chip-set>
                    <mat-chip>{{ baa.status }}</mat-chip>
                  </mat-chip-set>
                }
              </div>
              <div class="card-meta">
                @if (extractPartyName(baa.coveredEntity) || baa.coveredEntityFriendlyName) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">business</mat-icon>
                    CE: {{ baa.coveredEntityFriendlyName || extractPartyName(baa.coveredEntity) }}
                  </span>
                }
                @if (extractPartyName(baa.businessAssociateName) || baa.businessAssociateNameFriendlyName) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">handshake</mat-icon>
                    BA: {{ baa.businessAssociateNameFriendlyName || extractPartyName(baa.businessAssociateName) }}
                  </span>
                }
                @if (baa.effectiveDate) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">event</mat-icon>
                    {{ formatDate(baa.effectiveDate) }} - {{ formatDate(baa.expirationDate) }}
                  </span>
                }
              </div>
            </div>
            <mat-icon class="nav-arrow">chevron_right</mat-icon>
          </mat-card-content>
        </mat-card>
      }
    </div>
  } @else {
    <mat-card class="empty-state">
      <mat-card-content>
        <mat-icon>policy</mat-icon>
        <p>No BAAs associated</p>
      </mat-card-content>
    </mat-card>
  }
}
